module.exports = __webpack_public_path__ + "static/media/Car_main_preview.a9f16036.jpg";